/** True when expires_at is missing/invalid or already past `now`. */
export function isUrlExpired(
  expiresAt: string | null | undefined,
  now: Date | number = Date.now()
): boolean {
  if (!expiresAt) return true;
  const expiresMs = Date.parse(expiresAt);
  if (Number.isNaN(expiresMs)) return true;
  const nowMs = typeof now === 'number' ? now : now.getTime();
  return expiresMs <= nowMs;
}
